(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractOnlinePaymentHistoryDialogController', ContractOnlinePaymentHistoryDialogController);

    ContractOnlinePaymentHistoryDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function ContractOnlinePaymentHistoryDialogController($uibModalInstance, entity, Contrat) {
        var vm = this;

        vm.onlinePayment = entity;
        vm.histories = [];
        vm.isLoading = true;
        vm.clear = clear;

        loadHistory();

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadHistory() {
            Contrat.getOnlinePaymentHistory({idOnlinePayment: vm.onlinePayment.id}, function(result) {
                vm.histories = result;
                vm.isLoading = false;
            }, function() {
                vm.isLoading = false;
            });
        }
    }
})();
